import React, { useEffect } from 'react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import Button from "./ui/button";
import Input from "./ui/input";
import Label from "./ui/label";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api } from '../lib/api';
import { toast } from './ui/use-toast';
import { TIPOS_EMBARCACION } from '../constants/tiposEmbarcacion';

const DatosEmbarcacion = ({ embarcacion, setEmbarcacion, setPaso, clienteId }) => {
  // Actualizar cliente_id en embarcacion cuando cambie clienteId
  useEffect(() => {
    console.log('Cliente ID recibido en DatosEmbarcacion:', clienteId);
    if (clienteId) {
      setEmbarcacion((prev) => ({ ...prev, cliente_id: clienteId }));
    }
  }, [clienteId, setEmbarcacion]);

  const handleChange = (e) => {
    setEmbarcacion({ ...embarcacion, [e.target.name]: e.target.value });
  };

  const guardarEmbarcacion = () => {
    if (!clienteId) {
      toast({ title: 'Error', description: 'No se encontró el ID del cliente.', variant: 'destructive' });
      return;
    }

    const datosAEnviar = {
      cliente_id: clienteId, // Asegúrate de que el cliente_id se pasa aquí
      numeroMatricula: embarcacion.numeroMatricula,
      vencimientoMatricula: embarcacion.vencimientoMatricula,
      tipoEmbarcacion: embarcacion.tipoEmbarcacion,
      colorCasco: embarcacion.colorCasco,
      marca: embarcacion.marca,
      hp: embarcacion.hp,
      nombreFantasia: embarcacion.nombreFantasia,
      seguro: embarcacion.seguro,
      vencimientoSeguro: embarcacion.vencimientoSeguro,
      capacidad: parseInt(embarcacion.capacidad) || 0, // Ensure capacidad is an integer
    };

    console.log('Datos a enviar:', datosAEnviar);

    api.post('/embarcaciones', datosAEnviar)
      .then((response) => {
        console.log('Respuesta del servidor:', response.data);
        toast({ title: 'Embarcación guardada', description: 'Los datos de la embarcación se han guardado correctamente.' });
        setPaso(3); // Avanzar al siguiente paso
      })
      .catch((error) => {
        console.error('Error al guardar la embarcación:', error);
        toast({ title: 'Error', description: 'No se pudo guardar la embarcación.', variant: 'destructive' });
      });
  };

  function isEmbarcacionCompleto(embarcacion) {
    return embarcacion && embarcacion.numeroMatricula && embarcacion.vencimientoMatricula;
  }


  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Datos de la Embarcación</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
         <div>
          <Label htmlFor="numeroMatricula">Número de Matrícula</Label>
          <Input
            id="numeroMatricula"
            name="numeroMatricula"
            value={embarcacion.numeroMatricula}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="vencimientoMatricula">Vencimiento de Matrícula</Label>
          <Input
            id="vencimientoMatricula"
            name="vencimientoMatricula"
            type="date"
            value={embarcacion.vencimientoMatricula}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="tipoEmbarcacion">Tipo de Embarcación</Label>
          <Select
            value={embarcacion.tipoEmbarcacion}
            onValueChange={(value) =>
              setEmbarcacion({ ...embarcacion, tipoEmbarcacion: value })
            }
          >
            <SelectTrigger id="tipoEmbarcacion">
              <SelectValue placeholder="Seleccioná un tipo de embarcación" />
            </SelectTrigger>
            <SelectContent>
              {TIPOS_EMBARCACION.map((tipo) => (
                <SelectItem key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="colorCasco">Color del Casco</Label>
          <Input
            id="colorCasco"
            name="colorCasco"
            value={embarcacion.colorCasco}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="capacidad">Capacidad</Label>
          <Input
            id="capacidad"
            name="capacidad"
            type="number"
            value={embarcacion.capacidad}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="marca">Marca</Label>
          <Input
            id="marca"
            name="marca"
            value={embarcacion.marca}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="hp">HP</Label>
          <Input
            id="hp"
            name="hp"
            type="number"
            value={embarcacion.hp}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="nombreFantasia">Nombre de Fantasía</Label>
          <Input
            id="nombreFantasia"
            name="nombreFantasia"
            value={embarcacion.nombreFantasia}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="seguro">Seguro</Label>
          <Input
            id="seguro"
            name="seguro"
            value={embarcacion.seguro}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="vencimientoSeguro">Vencimiento del Seguro</Label>
          <Input
            id="vencimientoSeguro"
            name="vencimientoSeguro"
            type="date"
            value={embarcacion.vencimientoSeguro}
            onChange={handleChange}
            required
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button onClick={() => setPaso(1)}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Anterior
        </Button>
        <button onClick={guardarEmbarcacion} className="bg-blue-500 text-white mt-4 px-4 py-2 rounded">
          Guardar Embarcación
        </button>
        <Button disabled={!isEmbarcacionCompleto(embarcacion)} onClick={() => setPaso(3)}>
          Siguiente
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default DatosEmbarcacion;
